import useLenis from "../hooks/useLenis";
import { Header } from "../components/site/Header";
import { Hero } from "../components/site/Hero";
import { About } from "../components/site/About";
import { Ministries } from "../components/site/Ministries";
import { Marquee } from "../components/site/Marquee";
import { Productions } from "../components/site/Productions";
import { Events } from "../components/site/Events";
import { Journey } from "../components/site/Journey";
import { Gallery } from "../components/site/Gallery";
import { Contact } from "../components/site/Contact";
import { Footer } from "../components/site/Footer";

export default function Home() {
  useLenis();
  return (
    <div className="grain bg-ink text-white antialiased">
      <Header />
      <main>
        <Hero />
        <About />
        <Ministries />
        <Marquee />
        <Productions />
        <Events />
        <Journey />
        <Gallery />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
